/**
 * SendIcon — auto-generated by scripts/generate-icons.ts.
 * Do NOT edit manually — re-run `yarn codegen:icons` to regenerate.
 */

// SVGProps is used by the SVGR-generated component below.
import type { SVGProps } from 'react'
import { makeIcon } from '../make-icon'

interface SVGRProps {
  title?: string
  titleId?: string
}
const SendIconSvg = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fillRule="evenodd"
      d="M18.672 3.108a1.77 1.77 0 0 1 1.747.446l.017.013.023.027c.447.465.653 1.163.39 1.872l-5.455 14.72c-.616 1.66-3.003 1.526-3.435-.187l-1.59-6.353-6.37-1.6c-1.717-.431-1.843-2.818-.187-3.433l14.725-5.46zm-6.759 10.124 1.598 6.376.03.073a.2.2 0 0 0 .035.039c.028.02.07.038.12.04s.092-.01.122-.028a.2.2 0 0 0 .076-.102l4.938-13.325zm-7.545-3.119a.2.2 0 0 0-.102.076.2.2 0 0 0-.028.123c.003.05.02.09.04.118a.2.2 0 0 0 .11.064l6.394 1.606 6.926-6.934z"
      clipRule="evenodd"
    />
  </svg>
)

/** @see {@link https://design.reapit.com.au} Reapit DS icon */
export const SendIcon = makeIcon('SendIcon', SendIconSvg)
